import { Task } from '@task-utils/types';


export const SHELF_STATUS_UI: Partial<Record<Task.STATUS, { color: string; icon: string; trans: string }>> = {
	[Task.STATUS.CREATED]:      { color: Task.STATUS_COLORS.GRAY,  icon: "schedule",       trans: "PUNJENJE.STATUS.PLANNED" },
	[Task.STATUS.IN_EXECUTION]: { color: Task.STATUS_COLORS.BLUE,  icon: "play_circle",    trans: "PUNJENJE.STATUS.IN_PROGRESS" },
	[Task.STATUS.EXECUTED]:     { color: Task.STATUS_COLORS.GREEN, icon: "check_circle",   trans: "PUNJENJE.STATUS.DONE" },
	[Task.STATUS.UNDONE]:       { color: Task.STATUS_COLORS.RED,   icon: "do_not_disturb", trans: "PUNJENJE.STATUS.NO_SHOW" },
};

export const WORK_TYPE_TRANS: Record<Task.SHELF_WORK_TYPE, string> = {
	[Task.SHELF_WORK_TYPE.SHELF_STOCKING]:         "PUNJENJE.TYPE.SHELF_STOCKING",
	[Task.SHELF_WORK_TYPE.EXTRA_DISPLAY_STOCKING]: "PUNJENJE.TYPE.EXTRA_DISPLAY_STOCKING",
	[Task.SHELF_WORK_TYPE.ASSORTMENT_CONTROL]:     "PUNJENJE.TYPE.ASSORTMENT_CONTROL",
	[Task.SHELF_WORK_TYPE.SALES_VISIT]:            "PUNJENJE.TYPE.SALES_VISIT",
	[Task.SHELF_WORK_TYPE.OTHER]:                  "PUNJENJE.TYPE.OTHER",
};

export const WORK_TYPE_SHORT: Record<Task.SHELF_WORK_TYPE, string> = {
	[Task.SHELF_WORK_TYPE.SHELF_STOCKING]:         "PUNJENJE.TYPE_SHORT.SHELF_STOCKING",
	[Task.SHELF_WORK_TYPE.EXTRA_DISPLAY_STOCKING]: "PUNJENJE.TYPE_SHORT.EXTRA_DISPLAY_STOCKING",
	[Task.SHELF_WORK_TYPE.ASSORTMENT_CONTROL]:     "PUNJENJE.TYPE_SHORT.ASSORTMENT_CONTROL",
	[Task.SHELF_WORK_TYPE.SALES_VISIT]:            "PUNJENJE.TYPE_SHORT.SALES_VISIT",
	[Task.SHELF_WORK_TYPE.OTHER]:                  "PUNJENJE.TYPE_SHORT.OTHER",
};
